; (function() {

	// *************************************************************************
	// Increase-decrease
	// *************************************************************************

	function updateQuantity(selector, step) {
		let input = selector == "true" ? input.closest(".input-group").querySelector("input") : document.querySelector(selector);
		if (!input) {
			return;
		}

		let value = parseInt(input.value || 0);
		value += step;
		if (value < 1) {
			value = 1;
		}

		input.value = value;
	}

	document.addEventSelectorListener("click", "[data-increase]", function(event, target) {
		event.preventDefault();
		updateQuantity(target.getAttribute("data-increase"), 1);
	});
	document.addEventSelectorListener("click", "[data-decrease]", function(event, target) {
		event.preventDefault();
		updateQuantity(target.getAttribute("data-decrease"), -1);
	});


	// *************************************************************************
	// Price
	// *************************************************************************

	document.addEventSelectorListener("change", "input[type='radio'][data-price-label]", function(event, target) {
		let value = target.getAttribute("data-price-label");
		let element = document.getElementById("product-price-label");
		if (element) {
			element.innerText = value;
		}
	});


	// *************************************************************************
	// Gallery
	// *************************************************************************

	document.addEventSelectorListener("change", "input[data-gallery-select]", function(event, target) {
		let productVariantId = target.getAttribute("data-gallery-select");
		if (!productVariantId) {
			return;
		}

		for (let carousel of window.antlerio.carousels) {
			let slide = null;
			let slideIndex = 0;
			for (let i = 0; i < carousel.slides.length; ++i) {
				if (carousel.slides[i].matches("[data-product-variant='" + productVariantId + "']")) {
					slide = carousel.slides[i];
					slideIndex = i;
					break;
				}
			}
			if (slide) {
				carousel.move(slideIndex);
			}
		}
	});

}());